import './AvatarUpload.scss';

import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import Avatar from 'components/Avatar';
import Button from 'components/Button';
import H3 from 'components/H3';
import Icon from 'components/Icon';

export default class AvatarUpload extends React.Component {
    static propTypes = {
        avatar: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]),
        className: PropTypes.string,
        handleAvatarSelect: PropTypes.func.isRequired,
        instructions: PropTypes.string,
        isSaving: PropTypes.bool.isRequired
    };

    constructor() {
        super();

        this.avatarUploadRef = React.createRef();
    }

    render() {
        return (
            <section className={`c-avatar-upload ${this.props.className || ''}`}>
                <H3>
                    Profile Image
                </H3>

                <div className="c-avatar-upload__avatar--wrapper">
                    <Dropzone accept="image/*"
                              className="c-avatar-upload__dropzone"
                              multiple={false}
                              onDrop={this.props.handleAvatarSelect.bind(this)}
                              ref={this.avatarUploadRef}
                              style={{}}>
                        <Avatar
                            imageUrl={this.props.avatar == null || typeof this.props.avatar === 'string' ? this.props.avatar : this.props.avatar.preview}
                        />
                    </Dropzone>
                    <div className="c-avatar-upload__progress--overlay progress--overlay">
                        <div className="c-avatar-upload__progress--outer progress--outer">
                            <div id="progress" className="c-avatar-upload__progress--inner progress--inner" />
                        </div>
                        <div className="c-avatar-upload__progress--done progress--done">
                            <Icon type="check" />
                        </div>
                    </div>
                </div>

                <div className="c-avatar-upload__inner">
                    <div className="c-avatar-upload__instructions">
                        {this.props.instructions || 'Upload your photo. Recommended image size is 480px by 480px, png of jpeg format, less than 2mb.'}
                    </div>

                    <div className="c-avatar-upload__buttons">
                        <Button onClick={() => this.avatarUploadRef.current.open()}>
                            Select New Avatar
                        </Button>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AvatarUpload/index.js